module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-09.42279624.jpeg";